import type { RouteRecordRaw } from "vue-router";

export const settingsRoutes: RouteRecordRaw[] = [
    {
        path: "/settings",
        children: [
            {
                path: "index",
                name: "Settings",
                component: () => import("./views/SettingsScreen.vue"),
                meta: { requiresAuth: true },
            },
        ],
    },
];
